import React from "react";

import Bottombar from "../Bottombar";
import RightSideAccountSetting from ".";
import Topbar from "../Topbar";
import Header from "../Header";

function SmallScreenAccountSetting() {
  return (
    <div className="dark:bg-black h-[100vh] overflow-y-hidden">
        <Topbar />
    <div className=" overflow-y-hidden">
      
     <RightSideAccountSetting/>
    <Bottombar activeBar={'settings'} />
    </div>
    </div>
  );
}

export default SmallScreenAccountSetting;
